import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

/* -------------------- LEAVE MENU CONFIG -------------------- */

const LEAVE_MENU = [
  { key: "leave", label: "Leave" },
  { key: "optionalLeave", label: "Optional Leave" },
  { key: "cancelLeave", label: "Cancel Leave" },
  { key: "compOff", label: "Compensatory Off Grant Leave" },
];

/* -------------------- COMPONENT -------------------- */

const LeaveApply = () => {
  const [activeLeaveTab, setActiveLeaveTab] = useState("leave");

  return (
    <>
      {/* Top Filter */}
      <div className="p-2 border-bottom">
        <Form.Select className="w-auto" style={{ fontSize: 12 }}>
          <option>Apply</option>
          <option>Pending</option>
          <option>History</option>
        </Form.Select>
      </div>

      {/* Content */}
      <Container fluid>
        <Row>
          {/* Left Panel */}
          <Col
            md={3}
            className="border-end overflow-auto pt-2"
            style={{ height: "calc(100vh - 49px)" }}
          >
            {LEAVE_MENU.map((item) => (
              <div
                key={item.key}
                className={`channel-item mb-1 d-flex align-items-center ${
                  activeLeaveTab === item.key ? "active" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveLeaveTab(item.key)}
              >
                <div className="hstack gap-2">
                  <span>✓ {item.label}</span>
                </div>
              </div>
            ))}
          </Col>

          {/* Right Panel */}
          <Col
            md={9}
            className="overflow-auto p-0"
            style={{ height: "calc(100vh - 49px)" }}
          >
            {activeLeaveTab === "leave" && (
              <div>
                <div className="p-2 hstack justify-content-between border-bottom">
                  <small className="m-0">Apply Leave</small>
                  <Button
                    size="sm"
                    variant="primary"
                    style={{ fontSize: 13 }}
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    Save
                  </Button>
                </div>
                <p className="text-muted">Leave application form goes here.</p>
              </div>
            )}

            {activeLeaveTab === "optionalLeave" && (
              <div>
                <h6>Optional Leave</h6>
                <p className="text-muted">
                  Optional leave request form goes here.
                </p>
              </div>
            )}

            {activeLeaveTab === "cancelLeave" && (
              <div>
                <h6>Cancel Leave</h6>
                <p className="text-muted">
                  Cancel your previously applied leaves here.
                </p>
              </div>
            )}

            {activeLeaveTab === "compOff" && (
              <div>
                <h6>Compensatory Off Grant</h6>
                <p className="text-muted">
                  Comp-off grant leave form goes here.
                </p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LeaveApply;
